<template>
  <section class="works-carousel" style="margin-bottom: 15vh">
    <div class="col-sm-8 col-sm-offset-2 section-container-spacer">
      <div class="text-center">
        <h3>{{currentWorks.title}}</h3>
        <!--<p>{{currentWorks.describe}}</p>-->
      </div>
    </div>
    <div class="col-md-12">
      <div :id="carouselId" class="carousel slide projects-carousel">
        <!-- Carousel items -->
        <div class="carousel-inner">
          <div class="item" :class="{ active: gIdx === 0 }" v-for="(group,gIdx) in currentWorks.list" :key="gIdx">
            <div class="row">
              <div class="col-sm-4" v-for="(work,wIdx) in group" :key="wIdx">
                <a  title="" class="black-image-project-hover">
                    <!--<img src="@/assets/images/worksPics/w22-cover.jpg" class="img-responsive" v-if="work.cover != null" />-->
                    <img :src="work.cover" class="img-responsive" v-if="work.cover != null" />
                    <img src="../assets/images/work01-hover.jpg" alt="" class="img-responsive" v-else />
                </a>
                <div class="card-container card-container-lg">
                  <h4>{{work.appType}}/{{work.industryType}}</h4>
                  <h3>{{work.name}}</h3>
                  <p>{{work.describe}}</p>
                  <button type="button" class="btn btn-default" data-toggle="modal" data-target="#myModal" @click="onButtonClick(work)">
                    了解更多
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <template v-if="isSlideShow">
          <a class="left carousel-control" :href="slideHref" data-slide="prev">‹</a>
          <a class="right carousel-control" :href="slideHref" data-slide="next">›</a>
        </template>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: 'WorksCarousel',
  components: {},
  props: {
    currentWorks: {
      type: Object,
      require: true
    },
    carouselId: {
      type: String,
      default: "myCarousel"
    }
  },
  computed: {
    slideHref() {
      return `#${this.carouselId}`
    },
    // 是否显示侧边按钮
    isSlideShow() {
      return this.currentWorks.list.length > 1
    },
  },
  methods: {
    onButtonClick(work) {
      this.$emit('setModalWork', work)
    }
  },
}
</script>
<style lang="scss">
.works-carousel {
  min-height: 600px;

  .card-container p {
    word-wrap: break-word;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
}
</style>